module.exports = __webpack_public_path__ + "img/roll_l_f9.c83010fd.png";